import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const Icon = styled(IconFont)``

export const Container = styled.div`
    padding: 50px 40px;
    max-height: 100%;
    width: 100%;
    background-color: #fff;
`

export const FormContainer = styled.form``
